export default "__VITE_ASSET__c7c217b6__"